import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useStore } from "@/stores";
import DataSyncHistory from "@/views/components/DataSyncHistory.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataSyncTask',
  setup(__props) {

const store = useStore();

const showSyncWin = ref(false);
const showImportLogWin = ref(false);
const viewLogType = ref(-1);

const historyVisible = ref(false);

const isProgress = computed(() => store.getters["synctask/isProgress"]);

const importData = computed(() => (store.state as any).synctask.importTask);

const patentTextData = computed(() => (store.state as any).synctask.patentTextTask);

const getTaskImportStatus = (status: Nullable<string>) => {
  let message = "";
  switch (status) {
    case "RUNNING":
      message = "导入运行中";
      break;
    case "COMPLETED":
      message = "导入完成";
      break;
    case "NOT_STARTED":
    default:
      message = "未开始";
      break;
  }
  return message;
};

const getImportPercentage = () => {
  const message: any = (store.state as any).synctask.importTask;
  if (message.status === "COMPLETED") {
    return 100;
  }
  if (message.status === "NOT_STARTED") {
    return 0;
  }
  return parseInt((((message.finished + message.skipped) / (message.count || 1)) * 100).toString());
};

const getPatentTextPercentage = () => {
  const message: any = (store.state as any).synctask.patentTextTask;
  if (message.status === "COMPLETED") {
    return 100;
  }
  if (message.status === "NOT_STARTED") {
    return 0;
  }
  return parseInt(((message.finished / (message.count || 1)) * 100).toString());
};

const taskList = computed(() => {
  const syncTask: any = (store.state as any).synctask;
  return [
    {
      index: 0,
      name: "Excel项目数据导入",
      dataKey: "import",
      status: syncTask.importTask.status,
      percentage: getImportPercentage(),
    },
    {
      index: 1,
      name: "代码化全文/法律状态",
      dataKey: "patentText",
      status: syncTask.patentTextTask.status,
      percentage: getPatentTextPercentage(),
    },
    {
      index: 2,
      name: "数据同步",
      dataKey: "dataSync",
      status: syncTask.dataSyncTask.status,
      count: (store.state as any).synctask.dataSyncTask.totalCount,
    },
  ];
});

const restoreTask = () => {
  if (!store.getters["synctask/isProgress"]) {
    return;
  }
  const synctask: any = (store.state as any).synctask;
  if (synctask.importTask.status === "RUNNING") {
    store.dispatch("synctask/progressImport", {
      taskId: synctask.importTask.taskId,
      projectId: synctask.importTask.projectId,
    });
  }
  if (synctask.patentTextTask.status === "RUNNING") {
    store.dispatch("synctask/progressPatentText", {
      taskId: synctask.patentTextTask.taskId,
      projectId: synctask.patentTextTask.projectId,
    });
  }
};

restoreTask();

const closeTaskWin = () => {
  showSyncWin.value = false;
};

const viewSyncLog = (row: any) => {
  if (row.dataKey === "dataSync") {
    historyVisible.value = true;
  } else {
    viewLogType.value = row.index;
    showImportLogWin.value = true;
  }
};

const closeImportLogWin = () => {
  showImportLogWin.value = false;
};

return { __sfc: true,store, showSyncWin, showImportLogWin, viewLogType, historyVisible, isProgress, importData, patentTextData, getTaskImportStatus, getImportPercentage, getPatentTextPercentage, taskList, restoreTask, closeTaskWin, viewSyncLog, closeImportLogWin, DataSyncHistory }
}

})